export default {
  // 标题
  title: '萤石开源软件发布中心',
  footer: '©2018 杭州萤石软件有限公司',
  category: '类别',
  model: '模型',
  remark: '描述',
  license: '许可证',
  source: '源码',
  inquiry: '询问',
  searchPlaceholder: '输入关键字查询',
};



// WEBPACK FOOTER //
// ./src/locales/zh_CN.js